import ReactDOM from "react-dom";
import cn from 'classnames';

import { useClientContext, useTranslationContext } from 'hooks';
import { getClientOptions } from 'scripts/clients/index'

import { ReactComponent as Logo } from 'assets/logo/Logo-Full-White.svg';
import Icons from 'shared/Icons';

import classes from './Footer.module.scss';

export default function Footer() {
  const { client } = useClientContext();
  const { t } = useTranslationContext();
  const customFooterClass = getClientOptions(client)?.customFooterClass || '';
  const customFooterLinks = getClientOptions(client)?.customFooterLinks || [];

  return ReactDOM.createPortal(
    <footer className={cn(classes.Footer, 'Footer')}>
      {customFooterClass &&
        <div className={customFooterClass}>
          {customFooterLinks.map((link: any, index: number) => {
            return (
              <a key={index} className={link.customClass} href={link.url}>
                {link.label && <p>{link.label}</p>}
                {link.imgSrc && <img src={link.imgSrc}></img>}
                {link.iconType && <Icons iconType={link.iconType} iconClass={'footerCustomIcon'} />}
              </a>
            )
          })}
        </div>
      }
      <div className={cn(classes.poweredBy, 'poweredBy')}>
        {client.clientType !== 'Government' && client.campaignName  &&
          <div className={classes.paidForNotice}>
            <div className={classes.paidForText}>{t("Paid for by")}</div>
            <div className={classes.clientName}>{client.campaignName}</div>
            |
          </div>}
        <a className={classes.poweredByLink} href="https://www.repd.us">
          <div className={classes.poweredByText}>{t("Powered by")}</div>
          <Logo className={classes.footerLogo} />
        </a>
      </div>
    </footer>,
    document.body);
}
